import { render, staticRenderFns } from "./MesasGeral.vue?vue&type=template&id=7a1faf8b&scoped=true"
import script from "./MesasGeral.vue?vue&type=script&lang=js"
export * from "./MesasGeral.vue?vue&type=script&lang=js"
import style0 from "./MesasGeral.vue?vue&type=style&index=0&id=7a1faf8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1faf8b",
  null
  
)

export default component.exports